import { createTheme } from '@mui/material'

// main themes colors
let theme = createTheme({
    palette: {
        background: {
            default: '#F5F5F8'
        },
        primary: {
            light: '#000075',
            main: '#00004B',
            dark: '#000020',
        },
        secondary: {
            light: '#F8B160',
            main: '#F7914B',
            dark: '#F48430',
        },
        error: {
            main: '#ff0f0f'
        },
        warning: {
            light: '#FFF9E6',
            main: '#FFCC33',
            dark: '#996600',
            contrastText: '#805500'
        }
        // not used - Info / Success

    },
    typography: {
        button: {
            textTransform: "none",
        },
        fontFamily: [
            'Open Sans', 'sans - serif'
        ].join(',')
    },
})

export default createTheme(theme, {
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    // Unified base style for passive scan button
                    '&.Passive-Scan-Button': {
                        color: "#FFFFFF",
                        height: '65px',
                        fontWeight: 700,
                        fontSize: 20,
                        '&:hover': {
                            borderColor: 'black',
                            borderStyle: 'solid',
                            borderWidth: 1,
                        },
                        '&:disabled': {
                            border: 1,
                            color: "#FFFFFF"
                        }
                    },
                    '&.Scan-Button': {
                        color: "#FFFFFF",
                        backgroundColor: theme.palette.secondary.main,
                        height: '65px',
                        fontWeight: 700,
                        fontSize: 20,
                        '&:hover': {
                            backgroundColor: theme.palette.secondary.dark,
                            borderColor: 'black',
                            borderStyle: 'solid',
                            borderWidth: 1,
                        },
                        '&:disabled': {
                            backgroundColor: theme.palette.error.main,
                            border: 1,
                            color: "#FFFFFF"
                        },
                        '&.Scan-Button-Active:disabled': {
                            backgroundColor: theme.palette.secondary.main,
                            opacity: 0.7,
                        }
                    },
                    '&.Orange-Button': {
                        color: "#FFFFFF",
                        backgroundColor: theme.palette.secondary.main,
                        '&:hover': {
                            backgroundColor: '#F48430',
                        },
                        '&:disabled': {
                            backgroundColor: '#ffcaa1',
                            border: 1,
                            color: "#FFFFFF"
                        }
                    },
                    '&.Blue-Button': {
                        color: "#FFFFFF",
                        backgroundColor: theme.palette.primary.light,
                        '&:hover': {
                            backgroundColor: '#191E48',
                        },
                        '&:disabled': {
                            backgroundColor: 'red',
                            color: "#FFFFFF"
                        },
                        '&.Mui-disabled': {
                            color: "#FFFFFF",
                            backgroundColor: '#D3D3DE'
                        },
                    },
                    '&.Upload-Export-Blue': {
                        color: "#FFFFFF",
                        backgroundColor: theme.palette.primary.main,
                        height: '65px',
                        fontWeight: 700,
                        fontSize: 20,
                        '&:hover': {
                            backgroundColor: '#191E48',
                            border: 1,
                            borderColor: '#FFFFFF'
                        },
                        '&:disabled': {
                            color: "#FFFFFF",
                            backgroundColor: '#D3D3DE'
                        }
                    },
                    '&.Upload-Export-Blue-Small': {
                        color: "#FFFFFF",
                        backgroundColor: theme.palette.primary.main,
                        height: '32px',
                        minWidth: '80px',
                        fontWeight: 600,
                        fontSize: 15,
                        padding: '0 16px',
                        lineHeight: 1.2,
                        boxShadow: 'none',
                        '&:hover': {
                            backgroundColor: '#191E48',
                            border: 1,
                            borderColor: '#FFFFFF'
                        },
                        '&:disabled': {
                            color: "#FFFFFF",
                            backgroundColor: '#D3D3DE'
                        }
                    },
                    '&.Nav-Bar-Button': {
                        backgroundColor: '#2B3167',
                        color: "#FFFFFF",
                        '&:hover': {
                            backgroundColor: '#384085',
                        },
                    },
                    '&.Sign-In-Button': {
                        color: "#FFFFFF",
                        backgroundColor: '#F48430',
                        height: '65px',
                        fontWeight: 700,
                        fontSize: 20,
                        '&:hover': {
                            backgroundColor: '#191E48',
                            border: 1,
                            borderColor: '#FFFFFF'
                        },
                        '&:disabled': {
                            backgroundColor: '#D3D3DE',
                            color: "#FFFFFF"
                        }
                    }
                },
            },
        },
    }
})